export const ROUTE_PATH = {
  ROOT: "/",
  SPLASH: "/splash",
  LOGIN_ADMIN: "/login/admin",
  ACTIVITIES_ADMIN_SCAN: "/activity/scan",
  ACTIVITIES_FORM_PREVIEW_DETAIL: "/activity-form/admin/preview/:id",
  LOGIN: "/login",
  FORGET_PASSWORD: "/forget-password",
  FORGET_PASSWORD_COMPLETE: "/forget-password-complete",
  PRE_REGISTER: "/pre-register",
  NOTIFICATION: "/notification",
  REGISTER: "/register",
  PRODUCT_WARRANTEE_NOT_LOGIN: "/product-warrantee",
  PRODUCT_WARRANTEE_NOT_LOGIN_DETAIL: "/product-warrantee/:id",
  PRODUCT_WARRANTEE_SUCCESS_NOT_LOGIN: "/product-warrantee/:id/:status",
  SYSTEM: "/system",
  HOME: "/system/home",
  ACTIVITIES: "/system/home/activities",
  ACTIVITIES_DETAIL: "/system/home/activities/:id",
  ACTIVITIES_SEAT_BOOKING: "/system/home/activities/:id/seat-booking",
  ACTIVITY_CERTIFICATE: "/system/home/activities/:id/certificate",
  ONLINE_FORM_CERTIFICATE: "/system/home/online-form-certificate/:id",
  ONLINE_FORM_CERTIFICATE_BASE: "/system/home/online-form-certificate",
  ACTIVITY_QR_REGISTER: "/system/home/activities/:id/qr-register",
  ACTIVITIES_DETAIL_PREVIEW: "/activities/admin/preview/:id",
  ACTIVITY_FORM: "/system/home/activity-form",
  ACTIVITY_FORM_DETAIL: "/system/home/activity-form/:id",
  ACTIVITY_FORM_QUIZ:
    "/system/home/activity-form/:id/quiz/:question_id/:action",
  ACTIVITY_FORM_QUIZ_PREVIEW:
    "/system/home/activity-form/:id/quiz/:question_id/:action/preview",
  ACTIVITY_FORM_QUIZ_REQUEST_EDIT:
    "/system/home/activity-form/:id/quiz/:question_id/request-edit",
  ACTIVITY_FORM_QUIZ_THANK_YOU:
    "/system/home/activity-form/:id/quiz/:question_id/thank-you",
  ACTIVITY_FORM_PREVIEW: "/system/home/activity-form/preview/:id",

  ACTIVITY_FORM_NO_LOGIN: "/no-member/activity-form",
  ACTIVITY_FORM_QUIZ_NO_LOGIN:
    "/no-member/activity-form/:id/quiz/:question_id/:action",
  ACTIVITY_FORM_QUIZ_PREVIEW_NO_LOGIN:
    "/no-member/activity-form/:id/quiz/:question_id/:action/preview",
  ACTIVITY_FORM_QUIZ_THANK_YOU_NO_LOGIN:
    "/no-member/activity-form/:id/quiz/:question_id/thank-you",

  PRIVILEGE: "/system/privilege",
  PRIVILEGE_DETAIL: "/system/privilege/:id",
  PRODUCT_WARRANTEE: "/system/product-warrantee",
  PRODUCT_WARRANTEE_DETAIL: "/system/product-warrantee/:id",
  PRODUCT_WARRANTEE_SUCCESS_DETAIL: "/system/product-warrantee/:id/success",
  SPECIAL_POINTS: "/system/home/special-points",
  SPECIAL_POINTS_FEATURE: "/system/home/special-points/special",
  SPECIAL_POINTS_FAV: "/system/home/special-points/fav",
  SPECIAL_POINTS_FAV_QUICK_DETAIL: "/system/home/special-points/fav/test/:id",
  SPECIAL_POINTS_FAV_QUICK_SUCCESS_DETAIL:
    "/system/home/special-points/fav/test/:id/success",
  SPECIAL_POINTS_GAME: "/system/home/special-points/game",
  PDPA: "/pdpa",
  POINT_REDEEM: "/system/point-redeem",
  POINT_REDEEM_DETAIL: "/system/point-redeem/detail/:id",
  POINT_REDEEM_SHIPPING_DETAIL: "/system/point-redeem/detail/:id/shipping",
  POINT_REDEEM_QRCODE_DETAIL: "/system/point-redeem/detail/:id/qrcode",
  POINT_REDEEM_E_COUPON: "/system/point-redeem/e-counpon",
  POINT_REDEEM_VOUCHER: "/system/point-redeem/voucher",
  POINT_REDEEM_GIFT: "/system/point-redeem/gift",
  HISTORY: "/system/history",
  HISTORY_PRODUCT_WARRANTY: "/system/history/product-warranty",
  HISTORY_ACTIVITY: "/system/history/activity",
  HISTORY_PIANO_TUNING_DETAIL: "/system/history/product-warranty/:id",
  NEW: "/system/new",
  NEW_DETAIL: "/system/new/:id",
  PROFILE: "/system/profile",
  PROFILE_ACTIVITY_HISTORY: "/system/profile/activity-history",
  PROFILE_REDEEEM_HISTORY: "/system/profile/redeem-history",
  PROFILE_ME: "/system/profile/me",
  PROFILE_ME_INSTRUMENT_DETAIL: "/system/profile/me/:id",
  BOOKING: "/system/booking",
  BOOKING_DETAIL: "/system/booking/:category_id",
  CERIFICATE: "/certificate",
  CERIFICATE_DETAIL: "/certificate/:id",
  REWARD: "/system/reward",
  REWARD_DETAIL: "/system/reward/:id",

  MUSIC_HALL_AND_PRACTICE: "/system/music-hall-and-practice-detail",
  MUSIC_HALL_AND_PRACTICE_DETAIL: "/system/music-hall-and-practice-detail/:id",
  MUSIC_HALL_AND_PRACTICE_INFO_DETAIL:
    "/system/music-hall-and-practice-detail/:id/info",

  MUSIC_HALL: "/system/music-hall-detail",
  MUSIC_HALL_BOOKING_STEP_1: "/system/music-hall-detail/:id/booking/1",
  MUSIC_HALL_BOOKING_RENTAL_2: "/system/music-hall-detail/:id/booking/rental/2",
  MUSIC_HALL_BOOKING_STEP_2: "/system/music-hall-detail/:id/booking/2",
  MUSIC_HALL_BOOKING_STEP_3: "/system/music-hall-detail/:id/booking/3",
  MUSIC_HALL_BOOKING_STEP_4: "/system/music-hall-detail/:id/booking/4",
  MUSIC_HALL_BOOKING_STEP_5: "/system/music-hall-detail/:id/booking/5",
  MUSIC_HALL_BOOKING_STEP_6: "/system/music-hall-detail/:id/booking/6",
  MUSIC_HALL_BOOKING_STEP_7: "/system/music-hall-detail/:id/booking/7",
  MUSIC_HALL_BOOKING_STEP_8: "/system/music-hall-detail/:id/booking/8",
  MUSIC_HALL_BOOKING_STEP_9: "/system/music-hall-detail/:id/booking/9",
  MUSIC_HALL_BOOKING_CONDITION_1:
    "/system/music-hall-detail/:id/booking/condition/1",
  MUSIC_HALL_BOOKING_CONDITION_2:
    "/system/music-hall-detail/:id/booking/condition/2",

  MUSIC_PRACTICE_ROOM: "/system/music-practice-room",
  MUSIC_PRACTICE_ROOM_DETAIL: "/system/music-practice-room/:id",
  MUSIC_PRACTICE_ROOM_BOOKING_STEP_1:
    "/system/music-practice-room/:id/booking/1",
  MUSIC_PRACTICE_ROOM_BOOKING_STEP_2:
    "/system/music-practice-room/:id/booking/2",
  // ข้อมูลติดต่อ อยู่ระหว่าง step 1 (เลือกห้อง) กับ step 2 (วัน/เวลา) ไม่เปลี่ยนเลข step เดิมกันลิงก์เก่าพัง
  MUSIC_PRACTICE_ROOM_BOOKING_STEP_CONTACT:
    "/system/music-practice-room/:id/booking/contact",

  MUSIC_HALL_AND_PRACTICE_PREVIEW_DETAIL:
    "/system/music-hall-and-practice-detail/:id/preview",

  MUSIC_HALL_AND_PRACTICE_THANK_YOU:
    "/system/music-hall-and-practice-detail-thank-you",
};
